import { FormInput, FormSelect, FormCombobox } from "@/components";
import useFilter from "./useFilter";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { X } from "lucide-react";
import { FC } from "react";
import { FilterProps } from "./types";
import {
  ACTIVITY_TYPE,
  APPLICABLE_GRADES,
  GRADES,
  MODULE,
  SUB_MODULE,
  TOPIC,
  TOPIC_TLM,
  YEAR,
} from "../consts";

const Filter: FC<FilterProps> = ({ onCancel, filterData, setFilterData }) => {
  const { form, onSubmit, requiredFields, isMobile, onClear, gradeOptions, moduleOptions, submoduleOptions, activityTypeOptions, tlmTopicOptions } = useFilter({
    filterData,
    setFilterData,
    onCancel,
  });
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">Filter</DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg pt-[20px] pb-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[130px] px-1">
              <div className="grid grid-cols-1 gap-[25px]">
                <FormSelect
                  name={MODULE}
                  control={form.control}
                  label="Module"
                  placeholder="Please enter"
                  error={errors[MODULE]?.message}
                  isRequired={requiredFields.includes(MODULE)}
                  options={moduleOptions}
                />
                <FormSelect
                  name={SUB_MODULE}
                  control={form.control}
                  label="Submodule"
                  placeholder="Please enter"
                  error={errors[SUB_MODULE]?.message}
                  isRequired={requiredFields.includes(SUB_MODULE)}
                  options={submoduleOptions}
                />
                <FormInput
                  name={TOPIC}
                  control={form.control}
                  label="Curriculum topic"
                  placeholder="Please enter"
                  error={errors[TOPIC]?.message}
                  isRequired={requiredFields.includes(TOPIC)}
                />
                <FormInput
                  name={YEAR}
                  control={form.control}
                  label="Academic Year"
                  placeholder="Please enter"
                  error={errors[YEAR]?.message}
                  isRequired={requiredFields.includes(YEAR)}
                />
                <FormCombobox
                  name={APPLICABLE_GRADES}
                  control={form.control}
                  label="Applicable Grades"
                  placeholder="Please enter"
                  error={errors[APPLICABLE_GRADES]?.message}
                  isRequired={requiredFields.includes(APPLICABLE_GRADES)}
                  options={gradeOptions}
                  multiSelect
                />
                <FormSelect
                  name={ACTIVITY_TYPE}
                  control={form.control}
                  label="Activity Type"
                  placeholder="Please enter"
                  error={errors[ACTIVITY_TYPE]?.message}
                  isRequired={requiredFields.includes(ACTIVITY_TYPE)}
                  options={activityTypeOptions}
                />
                <FormSelect
                  name={TOPIC_TLM}
                  control={form.control}
                  label="KIT Name"
                  placeholder="Please enter"
                  error={errors[TOPIC_TLM]?.message}
                  isRequired={requiredFields.includes(TOPIC_TLM)}
                  options={tlmTopicOptions}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 absolute bottom-3 w-full bg-white pb-[25px] z-[3]">
              <div className="flex justify-end">
                <Button
                  variant="ghost"
                  type="button"
                  className="text-red-600"
                  onClick={onClear}
                >
                  Clear All
                </Button>
              </div>
              <Button type="submit">Apply Filter</Button>
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default Filter;
